import { useEffect, useState } from "react";
import ModalWindow from "../../../../../../../Components/ModalWindow/ModalWindow.js";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager.js";
import UsersRequests from "../../../../../../../Services/Api/UserRequests.ts";
import GroupUsersRequests from "../../../../../../../Services/Api/GroupUsersRequests.ts";
import ScrollableList from "../../../../../../../Components/ScrollableList/ScrollableList.js";
import CheckBox from "../../../../../../../Components/CheckBox/CheckBox.js";
import ScpPermissions from "../../../../../../../Services/Permissions/Data/ScpPermissions.js";
import { CheckPermissionForEdit } from "../../../../../../../Services/Permissions/PermissionManager.js";

const AddUserModal = ({groupId, groupUsers, refresh, hide}) => {
    const groupUsersId = groupUsers.map(x => x.userId)

    const usersRequests = new UsersRequests();
    const groupUsersRequests = new GroupUsersRequests();

    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [,setRefreshConst] = useState("");

    const [step, setStep] = useState(0);
    const [permission, setPermission] = useState(0);

    const ChangeSelection = (id) => {
        let selected = selectedUsers;

        let existing = selectedUsers.find(x => x == id);

        if(existing) {
            selected.splice(selectedUsers.indexOf(existing), 1);
        }else{
            selected.push(id);
        }

        setRefreshConst(new Date().toISOString());
        setSelectedUsers(selected);
    }

    const AddUsers = () => {
        if(selectedUsers.length > 0){
            const data = {
                groupId: groupId,
                userIds: selectedUsers,
                permissions: permission
            }
            groupUsersRequests.Add(data, () => { refresh(); hide(); });
        }else {
            AddToastNotification("Musisz wybrać przynajmniej jedego użytkownika!", 0)
        }
    }

    useEffect(() => {
        usersRequests.GetAll((data) => {
            const processedData = data.filter(x => !groupUsersId.includes(x.panelUser.id)).map((x) => {
                return {
                    img: {
                        src: x.steamPlayer?.avatarfull,
                        className: "h-8 w-8 rounded-sm"
                    },                
                    id: x.panelUser.id,
                    columns: [
                        <p>{x.panelUser.login}</p>,
                    ],
                    text: [x.panelUser.login],
                };
            })

            setUsers(processedData)
        });
    }, []);

    if(!users)
        return (<></>)
    
    const getButtons = () => {
        if(step == 0)
            return [
                { Text: "Dalej", onClick: () => { 
                    if(selectedUsers.length > 0)
                        setStep(1) 
                    else
                        AddToastNotification("Musisz wybrać przynajmniej jedego użytkownika!", 0)
                }},
                { Text: "Anuluj",  onClick: () => { hide() }, className: "modalSecondaryBtn" }
            ]
        else
            return [
                { Text: "Dodaj", onClick: () => { AddUsers() }},
                { Text: "Powrót",  onClick: () => { setStep(0) }, className: "modalSecondaryBtn" }
            ]
    }

    return (
        <ModalWindow 
            title={"Dodaj użytkownika do grupy"}
            minWidth={"60%"}
            content={
                <div>
                    { step == 0 &&
                        <ScrollableList 
                            data={users}
                            listClass={"overflow-y-auto overflow-x-hidden max-h-[35.5vh]"}
                            customButtons={[
                                { render: (data) => { return (<CheckBox value={selectedUsers.find(x => x == data.id)} onChange={() => {ChangeSelection(data.id)}}/>) } }
                            ]}
                        />
                    }
                    { step == 1 &&
                        <>
                            <h2 className="mb-5">Uprawnienia</h2>
                            <div className="columns-2 mb-20">
                                { Object.values(ScpPermissions).filter(x => !x.hidden).map(permissionData => 
                                    <CheckBox 
                                        value={CheckPermissionForEdit(permission, permissionData.value)} 
                                        text={permissionData.text} 
                                        onChange={() => {
                                            if(CheckPermissionForEdit(permission, permissionData.value))
                                                setPermission(permission - permissionData.value)
                                            else
                                                setPermission(permission | permissionData.value)
                                        }}
                                    />
                                )}
                            </div>
                        </>
                    }                    
                </div>
            }
            buttons={getButtons()}
        />
    )
}

export default AddUserModal;